export const getDifferenceDays = (
    firstDate: Date,
    secondDate: Date
): number => {
    const oneDay = 24 * 60 * 60 * 1000;
    firstDate = convertDateWithoutTime(firstDate);
    secondDate = convertDateWithoutTime(secondDate);

    return (
        Math.floor(
            Math.abs(firstDate.getTime() - secondDate.getTime()) / oneDay
        ) + 1
    );
};

export const getDifferenceHours = (
    firstDate: Date,
    secondDate: Date
): number => {
    return  (Math.abs(firstDate.getTime() - secondDate.getTime())/1000) / (60*60);
};

export const convertDateWithoutTime = (date: Date): Date => {
    const result = date;
    result.setHours(0, 0, 0, 0);
    return result;
};